import DTM from 'shared/helpers/DTM';

export const trackLoginSignupFromWishlist = () => {
  DTM.track('wislist-login-signup');
};

export const trackLoginNudgeClosed = () => {
  DTM.track('login-nudge-closed');
};

export const trackAddToWishlistClicked = (
  productId: string,
  price: number,
  isOutOfStock: boolean
) => {
  DTM.track('track-add-to-wishlist-clicked', {
    productToAddOrRemoveFromWishlistOrNotify: productId,
    priceOfWishlistProduct: String(price),
    isWishlistProductOutOfStock: String(isOutOfStock),
  });
};

export const trackRemoveFromWishlistClicked = (
  productId: string,
  price: number,
  isOutOfStock: boolean
) => {
  DTM.track('track-remove-from-wishlist-clicked', {
    productToAddOrRemoveFromWishlistOrNotify: productId,
    priceOfWishlistProduct: String(price),
    isWishlistProductOutOfStock: String(isOutOfStock),
  });
};

export const trackNotifyMeClicked = (productId: string, price: number, isOutOfStock: boolean) => {
  DTM.track('track-notify-me-clicked', {
    productToAddOrRemoveFromWishlistOrNotify: productId,
    priceOfWishlistProduct: String(price),
    isWishlistProductOutOfStock: String(isOutOfStock),
  });
};
